<template>
  <div>
    <!-- <search-bar
      @search="searchQC"
      name=""
      placeholder="输入产品编号、名称、型号、工单号进行查找"
      ref="searchBar"
    /> -->
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        :to="{name: 'OutProductionQCReportDetail', params: { item }}"
      >
        <div class="weui-cell__bd">
          <p>{{item.qc_code}}</p>
          <p class="list-item-muted" v-format="'yyyy-MM-dd'">{{item.qc_date}}</p>
        </div>
        <div class="weui-cell__ft">
          <p>{{item.qc_macode}}</p>
          <span
            class="list-item-muted"
          >
            {{item.pr_code}} {{ item.pr_detail }}
          </span>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}条</label>
    </div>
  </div>
</template>

<script>
// import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    FilterBar,
    ScrollList
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/qc/report/qc",
      params: {
        mode: "DETAIL",
        number: 1,
        size: 10,
      },
      filters: [
        {
          type: "date",
          name: "qc_date"
        }
      ]
    }
  },
  mounted() {
    this.onSearch()
  }
}
</script>